import React, { Component } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';
import OldSignatoriesAccordian from './components/oldSignatoriesAccordian';

class OldSignatoriesPage extends Component {
  constructor(props) {
    super(props);
    this.state = { isFormEditable: false };
    this.onEditButtonClick = this.onEditButtonClick.bind(this);
  }

  onEditButtonClick() {
    this.setState({ isFormEditable: !this.state.isFormEditable });
  }

  render() {
    const {
      saveOldSignatoriesForm,
      oldSignatories,
      bankId,
      brandId,
      redirectToPersonalInfo,
      removeOldSignatories,
      updateOldSignatories
    } = this.props;
    return (
      <Form
        onSubmit={saveOldSignatoriesForm}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Content>
              {({
                oldSignatoriesPageTitle = '',
                oldSignatoriesPara1 = '',
                oldSignatoriesPara2 = '',
                oldSignatoriesConfirmText = '',
                addSomeoneElseText = ''
              }) => (
                <div>
                  <PageHeading>{oldSignatoriesPageTitle}</PageHeading>
                  <StandardBody>
                    <p>{oldSignatoriesPara1}</p>
                    <p>{oldSignatoriesPara2}</p>
                  </StandardBody>
                  {oldSignatories &&
                    oldSignatories.length > 0 &&
                    oldSignatories.map((signatory, index) => (
                      <OldSignatoriesAccordian
                        key={`signatories_${index}`}
                        signatory={signatory}
                        brandId={brandId}
                        bankId={bankId}
                        removeOldSignatories={removeOldSignatories}
                        updateOldSignatories={updateOldSignatories}
                        signatoriesIndex={index}
                      />
                    ))}

                  <ActionButton.Add
                    className="u-margin-top-3 u-margin-bottom-2"
                    onClick={e => {
                      e.preventDefault();
                      redirectToPersonalInfo();
                    }}
                    labelText={addSomeoneElseText}
                  />
                  <StandardBody>
                    <p>{oldSignatoriesConfirmText}</p>
                  </StandardBody>
                  <Submit hideExit />
                </div>
              )}
            </Content>
          </form>
        )}
      />
    );
  }
}
OldSignatoriesPage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveOldSignatoriesForm: PropTypes.func.isRequired
};

export default OldSignatoriesPage;
